import React from 'react';
import './MediaParagraph.css';

const LeftMediaRightPara = ({ block }) => {
    const isVimeo = block.media && block.media.includes('vimeo.com');
    const isVideo = block.media && block.media.toLowerCase().endsWith('.mp4');
    const isPortrait = block.aspect === 'portrait';

    return (
        <div className={`media-paragraph-container left-media-right-para ${isPortrait ? 'portrait-media' : ''}`}>
            <div className="media-side">
                {isVimeo ? (
                    <div className={`vimeo-media-wrapper ${isPortrait ? 'vimeo-portrait' : ''}`}>
                        <iframe
                            src={block.media}
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                            title="vimeo-video"
                        />
                    </div>
                ) : isVideo ? (
                    <video src={block.media} autoPlay muted loop playsInline className="media-paragraph-video" />
                ) : (
                    <img src={block.media} alt="" className="media-paragraph-image" />
                )}
            </div>
            <div className="text-side">
                {block.text}
            </div>
        </div>
    );
};

export default LeftMediaRightPara;
